import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import '@fortawesome/fontawesome-free/css/all.min.css'


import money from 'vuejs-money'

import VueLuxon from 'vue-luxon'

// Global Components
import './global-components'
// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/tour'

import VueTheMask from 'vue-the-mask'

import VueSweetalert2 from 'vue-sweetalert2'

import AxiosPlugin from 'vue-axios-cors'

import VueProgress from 'vue-progress-path'
import App from './App.vue'
import store from './store'
import router from './router'
import { formatDate, formatTaxId, formatValue } from '@/utils'
import inactivity from './mixins/inactivity'

Vue.config.devtools = false

Vue.mixin(inactivity)

Vue.use(VueProgress)

Vue.use(AxiosPlugin)

Vue.use(VueSweetalert2)

Vue.use(VueTheMask)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

Vue.use(money)

Vue.filter('date', date => formatDate(date))
Vue.filter('tax_id', taxId => formatTaxId(taxId))
Vue.filter('value', value => formatValue(value))
// Composition API
Vue.use(VueCompositionAPI)

// date plugin
Vue.use(VueLuxon)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

store.dispatch('user/fetch').finally(() => new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app'))
